import React from 'react'
import '@app/config/config'

import { Provider } from 'react-redux'
import { store } from '@app/store/store'
import { createRoot } from 'react-dom/client'

import App from './App'
import ErrorBoundary from './hocs/error-boundary'
import { GlobalErrorPage } from './features/global-error'

const container = document.getElementById('root') as HTMLElement
const root = createRoot(container)

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ErrorBoundary fallback={(resetError) => <GlobalErrorPage resetError={resetError} />}>
        <App />
      </ErrorBoundary>
    </Provider>
  </React.StrictMode>,
)
